module.exports = __webpack_public_path__ + "static/media/bell-beaker_EBA_england_preview.6f8b61d0.png";